<template>
    <div>
        <div class="modal-header">
            <h5 class="modal-title">{{ shopId ? 'Edit Shop' : 'Tambah Shop' }}</h5>
            <button type="button" class="close" @click="$emit('close')">
                <span>&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form @submit.prevent="submitForm">
                <div class="form-group">
                    <label>Nama Shop *</label>
                    <input type="text" v-model="form.name" class="form-control" required />
                </div>
                <div class="form-group">
                    <label>Slug *</label>
                    <input type="text" v-model="form.slug" class="form-control" required />
                    <small class="form-text text-muted">URL-friendly identifier (contoh: my-shop)</small>
                </div>
                <div class="form-group">
                    <label>Deskripsi</label>
                    <textarea v-model="form.description" class="form-control" rows="3"></textarea>
                </div>
                <div class="form-group">
                    <label>Custom Domain</label>
                    <input type="text" v-model="form.custom_domain" class="form-control" placeholder="contoh: shop.example.com" />
                </div>
                <div class="form-group">
                    <label>Logo Shop</label>
                    <div v-if="form.logo_url" class="mb-2">
                        <img :src="form.logo_url" alt="Logo Preview" style="max-width: 200px; max-height: 200px; border-radius: 8px; border: 1px solid #ddd;" />
                        <button type="button" @click="removeLogo" class="btn btn-sm btn-danger ml-2">
                            <i class="fas fa-times"></i> Hapus
                        </button>
                    </div>
                    <div v-if="uploadingLogo" class="mb-2">
                        <div class="spinner-border spinner-border-sm text-primary" role="status">
                            <span class="sr-only">Uploading...</span>
                        </div>
                        <span class="ml-2">Mengupload logo...</span>
                    </div>
                    <input 
                        type="file" 
                        @change="onLogoChange" 
                        class="form-control" 
                        accept="image/*"
                        ref="logoInput"
                        :disabled="uploadingLogo"
                    />
                    <small class="form-text text-muted">Upload logo shop atau masukkan URL</small>
                    <input 
                        type="text" 
                        v-model="form.logo_url" 
                        class="form-control mt-2" 
                        placeholder="atau masukkan URL langsung: https://..." 
                    />
                </div>
                <div class="form-group">
                    <label>Status</label>
                    <select v-model="form.status" class="form-control">
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                    </select>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="$emit('close')">Batal</button>
                    <button type="submit" class="btn btn-primary" :disabled="loading">
                        {{ loading ? 'Menyimpan...' : 'Simpan' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ShopForm',
        props: {
            shopId: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                form: {
                    name: '',
                    slug: '',
                    description: '',
                    custom_domain: '',
                    logo_url: '',
                    status: 'active'
                },
                loading: false,
                uploadingLogo: false,
                logoFile: null
            };
        },
        mounted() {
            if (this.shopId) {
                this.loadShop();
            }
        },
        methods: {
            async loadShop() {
                try {
                    const response = await this.$store.dispatch('shop/shop_detail', this.shopId);
                    const shop = response.data.data.shop;
                    this.form = {
                        name: shop.name,
                        slug: shop.slug,
                        description: shop.description || '',
                        custom_domain: shop.custom_domain || '',
                        logo_url: shop.logo_url || '',
                        status: shop.status
                    };
                } catch (error) {
                    this.$toast.error('Gagal memuat data shop');
                }
            },
            onLogoChange(e) {
                const file = e.target.files[0];
                if (file) {
                    this.logoFile = file;
                    this.uploadLogo();
                }
            },
            removeLogo() {
                this.form.logo_url = '';
                this.logoFile = null;
                if (this.$refs.logoInput) {
                    this.$refs.logoInput.value = '';
                }
            },
            async uploadLogo() {
                if (!this.logoFile) return;
                
                this.uploadingLogo = true;
                try {
                    const formData = new FormData();
                    formData.append('file', this.logoFile);
                    const response = await this.$store.dispatch('cdn_upload', formData);
                    if (response && response.data && response.data.data && response.data.data.url) {
                        this.form.logo_url = response.data.data.url;
                        this.$toast.success('Logo berhasil diupload');
                    }
                } catch (error) {
                    this.$toast.error('Gagal upload logo');
                } finally {
                    this.uploadingLogo = false;
                }
            },
            async submitForm() {
                // Upload logo if file selected but not yet uploaded
                if (this.logoFile && !this.uploadingLogo) {
                    await this.uploadLogo();
                }

                this.loading = true;
                try {
                    if (this.shopId) {
                        await this.$store.dispatch('shop/shop_update', {
                            id: this.shopId,
                            ...this.form
                        });
                        this.$toast.success('Shop berhasil diupdate');
                    } else {
                        await this.$store.dispatch('shop/shop_create', this.form);
                        this.$toast.success('Shop berhasil dibuat');
                    }
                    this.$emit('saved');
                } catch (error) {
                    this.$toast.error(error.response?.data?.message || 'Gagal menyimpan shop');
                } finally {
                    this.loading = false;
                }
            }
        }
    };
</script>

